import {
  R_STATISTICAL_PROGRAMMING, R_CLINICAL_DATA_MANAGEMENT, R_MEDICAL_WRITING, R_REGULAR_AFFAIRS,
} from '@/router/routes';

export default [
  {
    title: 'Statistical Programming',
    text: 'Turn un-interpretable validated clinical data into something meaningful with clinical trial reporting to make informed decisions and submission ready deliverables.',
    routeName: R_STATISTICAL_PROGRAMMING,
    imgSrc: '/assets/images/services/statisticalProgramming.svg',
    linkLabel: 'Interpret Your Data',
  },
  {
    title: 'Clinical Data Management',
    text: 'Flexible and modern data collection, capture and management methods for your research data to ensure error free and timely database locks.',
    routeName: R_CLINICAL_DATA_MANAGEMENT,
    imgSrc: '/assets/images/services/clinicalDataManagement.svg',
    linkLabel: 'Capture Your Data',
  },
  {
    title: 'Medical Writing',
    text: 'Give your regulatory submission the best chance for approval with well written regulatory documents throughout all stages of the drug development process.',
    routeName: R_MEDICAL_WRITING,
    imgSrc: '/assets/images/services/medicalWriting.svg',
    linkLabel: 'Document Your Results',
  },
  {
    title: 'Regulatory Affairs',
    text: 'Ensure that your regulatory submission isn’t needlessly delayed through a lack of quality or integrity of data.',
    routeName: R_REGULAR_AFFAIRS,
    imgSrc: '/assets/images/services/regulatoryAffairs.svg',
    linkLabel: 'Learn More',
  },
];
